import { FC } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import Home from './routes/Home';
import Refresh from './routes/Refresh';

const App: FC = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/2025" element={<Home year={2025} />} />
      <Route path="/refresh" element={<Refresh />} />
    </Routes>
  </Router>
);

export default App;
